import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-user-config-value-renderer',
  templateUrl: './user-config-value-renderer.component.html',
  styleUrls: ['./user-config-value-renderer.component.scss']
})
export class UserConfigValueRendererComponent implements ICellRendererAngularComp {

  fromComponent = '';

  sectionName = '';

  params: any;

  user_mgmt_enabled: boolean;

  user_tiers_enabled: boolean;

  tiersArr: Array<string>;

  isUserWebhookPresent = false;

  isNewRecord = false;

  approval_flow_enabled_for_app = false;

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    this.fromComponent = this.params.context.componentParent.fromComponent;
    this.sectionName = this.params.context.componentParent.sectionName;
    this.user_mgmt_enabled = this.params.context.componentParent.configOptionsOnChanges?.user_mgmt_enabled;
    this.user_tiers_enabled = this.params.context.componentParent.configOptionsOnChanges?.user_tiers_enabled;
    this.tiersArr = this.params.context.componentParent.tiersArr;
    this.isUserWebhookPresent = this.params.context.componentParent?.isUserWebhookPresent;
    // console.log(this.params);
    this.isNewRecord = this.params?.data.isNew ? true : false;
    this.approval_flow_enabled_for_app = this.params.context.componentParent?.appDetailsData?.approval_flow_enabled ? true : false;

    // console.log('abcd config renderer', params);
    // console.log('abcd config', this.user_mgmt_enabled, this.user_tiers_enabled)
  }

  createIdString() {
    if (this.fromComponent && this.sectionName) {
      return this.fromComponent + '-' + this.sectionName + '-configSelect'
    } else {
      return 'configSelect';
    }
  }

  refresh(): boolean {
    return false;
  }

}
